<script setup>
import { slugifyString } from '~/utils/slugify'

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  ingredients: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <div class="row justify-content-center">
    <div class="col-12 col-800-10 col-1200-8">
      <h2
        v-if="props.title"
        :id="slugifyString(props.title)"
        class="equal-small-2 equal-small-2--bold-uppercase title"
      >
        {{ props.title }}
      </h2>
      <div class="ingredients">
        <div
          v-for="(ingredient, index) in props.ingredients"
          :key="index"
          class="ingredients-element"
        >
          <div class="ingredients-element__name">
            <p class="equal-base">
              {{ ingredient.amount }}
            </p>
          </div>
          <div class="ingredients-element__quantity">
            <p class="equal-base">
              {{ ingredient.name }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/node_modules/bootstrap/scss/mixins';
@import '@/assets/scss/variables.scss';

.title {
  color: $color-disabled;
}

.ingredients {
  margin-top: 10px;
  &.small-2 {
    color: $color-disabled;
    font-weight: bold;
    text-transform: uppercase;
  }
  &:last-child {
    border-bottom: 1px solid $color-dark-04;
  }
  .ingredients-element {
    display: flex;
    gap: 10px;
    border-top: 1px solid $color-dark-04;
    p {
      margin-bottom: 0;
      min-width: 140px;
      padding: 7px 0;
    }
  }
  @include media-breakpoint-down(640) {
    .ingredients-element {
      p {
        min-width: 20vw;
      }
    }
  }
}
</style>
